




















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import CustomerDetail from "../../../store/entities/customers/create-customer";
import Address from "../../../store/entities/address";
import AddressModal from "../../components/address-modal.vue";
import _ from "lodash";
import AppConsts from "@/lib/appconst";

Vue.use(require("vue-moment"));

@Component({
  components: { AddressModal },
})
export default class CreateCustomer extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  addressModalShow: boolean = false;
  customer: CustomerDetail = new CustomerDetail();
  spinShow: boolean = false;
  selectedAddress: Address = new Address();
  customerAddress: Address = new Address();
  types = [];
  tplCode: string = null;
  tpl = { totalWeight: null, totalVolume: null };
  tplLoading: boolean = false;
  tpls = [];
  isClient() {
    return this.$store.state.session.client != null;
  }
  searchTpl_OnPress = _.debounce(this.searchTpls, AppConsts.debounceDelayTime, {
    leading: false,
    trailing: true,
  });
  async searchTpls(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.tplLoading = true;
    this.$store
      .dispatch({
        type: "tpl/searchTplForSelect",
        data: {
          keyWord: keyword,
        },
      })
      .then((result) => {
        this.tpls = result;
        this.tplLoading = false;
      });
  }
  getCustomerTypes() {
    this.types = [];
    this.$store
      .dispatch({
        type: "customerType/getCustomerType",
        data: { hasAllItem: false },
      })
      .then((result) => {
        this.types = result;
        this.$set(
          this.customer,
          "type",
          this.types.length === 0 ? "" : this.types[0].id
        );
      });
  }

  updateAddress() {
    this.customerAddress = this.selectedAddress;
  }
  openModalAddress() {
    this.addressModalShow = true;
  }
  save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CreateCustomer"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: () => {
        this.spinShow = true;
        this.customer.address = this.customerAddress;
        if (!_.isNil(this.tplCode) && !_.isEmpty(this.tplCode)) {
          this.customer.defaultTPLCode = this.tplCode;
        }
        this.$store
          .dispatch({
            type: "customer/create",
            data: this.customer,
          })
          .then(() => {
            Util.showSuccessMsg(this, "Success.CreateCustomer");
            this.reset();
            this.onGoBack();
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  onGoBack() {
    this.$root.$router.push({ name: "customer" });
  }

  reset() {
    this.spinShow = false;
    this.addressModalShow = false;
    this.customer = null;
    this.selectedAddress = new Address();
    this.customerAddress = new Address();
    this.tpls = [];
    this.tplCode = "";
  }

  async created() {
    this.spinShow = true;
    try {
      this.customer.address = new Address();
      this.getCustomerTypes();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  customerRule = {
    code: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Code")),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    phone: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("ContactPhone")
        ),
        trigger: "blur",
      },
    ],
    type: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Type")),
        trigger: "blur",
      },
    ],
    fullAddress: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Address")),
        trigger: "blur",
      },
    ],
  };
}
